<script lang="ts">
  import SectionCarteDeliveryList from '@/generated/sections/SectionCarteDeliveryList.vue';
  import Delivery, { DeliveryTypes } from '@/generated/classes/Delivery';
  import Transaction, { TransactionTypes } from '@/generated/classes/Transaction';
  import { ListFilter, ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { defineComponent } from "vue";
  import ListData from '@/extend/classes/ListData';

  export default defineComponent({
    components: {},
    extends: SectionCarteDeliveryList,
    data() {
      return {
        waitedCb: new Delivery(),
        waitedLoaded: false,
        currentPage:1
      };
    },
    created() {
      this.getWaitedReccord();
    },
    computed: {
      canAdd(): boolean {
        return false;
      },

      items(): unknown[] {
        if (this.waitedLoaded && (!this.isInitialised || (this.route && this.route.sectionObjId != this.lastRoute.sectionObjId))) {
          this.defaultFilter();
          this.setLastRoute();
          this.loadTable();
          this.isInitialised = true;
        }
        if (this.listData.reccords.length > 0) {
          this.$emit('selectItem', this.listData.reccords[0]);
        }
        return this.listData.reccords;
      },
      pageLimit(): number {
        return 3;
      },
    },
    methods: {
      loadTable(): void {
        if (this.loading) return;
        this.loading = true;
        Delivery.list(this.filter).then((res) => {
          this.listData = new ListData();
          this.listData = res;
          this.pageNumber = res.currentPage;
          if (res.currentPage == 1) {
            if (this.waitedCb.count > 0) {
              this.listData.reccords.unshift(this.waitedCb)
            }          
          }
          this.loading = false;
        });
        this.pageNumber = 1;
      },
      defaultFilter(): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = DeliveryTypes.CARTE_BANCAIRE;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      getWaitedReccord(): void {
        const filter = new ListFilter();
        filter.pageLimit = 1000;
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.CARTE_BANCAIRE_RECU;
          columnFilter.filters.push(choix);
          filter.columnsFilter.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "deliveryId";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = 0;
          columnFilter.filters.push(choix);
          filter.columnsFilter.push(columnFilter);
        }
        Transaction.list(filter).then((data) => {
          this.waitedCb.canUpdate = false;
          this.waitedCb.canDelete = false;
          this.waitedCb.dateDelivery = 'A venir';
          this.waitedCb.reference = 'Paiements attendus';
          this.waitedCb.count = data.totalCount;
          this.waitedCb.amount = data.reccords.reduce((sum, reccord) => sum + reccord.amount, 0);
          this.waitedLoaded = true;
        });

      },
      selectItem(event: any, row: any): void {
        const obj = row.item as Delivery;
        this.$emit('selectItem', obj);
      },
      getActionColor(delivery: Delivery): string {
        if (delivery.id == 0) {
          return '#F40F02';
        } else {
          return '#1D6F42';
        }
      },
      mdiAction(transaction: Transaction): string {
          return 'fas fa-landmark';
      },
      hasAction(transaction: Transaction): boolean {
        return true;
      },
      execAction(transaction: Transaction): void {        
      },
    }
  })

</script>
